//# sourceMappingURL=data_sources.mjs.map
/// <reference types="./data_sources.d.mts" />
import * as $when from "../../../altar/altar/when.mjs";
import * as $user_id from "../../../data_types/data/auth/user_id.mjs";
import * as $data_source from "../../../data_types/data/data_source.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $language from "../../../data_types/data/translate/language.mjs";
import * as $iso639 from "../../../data_types/data/translate/language/iso639.mjs";
import * as $checkbox from "../../../ds/ds/components/checkbox.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $label from "../../../ds/ds/components/label.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $icons from "../../../ds/ds/icons.mjs";
import * as $position from "../../../ds/ds/position.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $compose from "../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $ievent from "../../../redraw_dom/redraw/dom/event/input.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $ds_effects from "../../admin/effects/data_sources.mjs";
import * as $data_sources from "../../data/data_sources.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList, CustomType as $CustomType, isEqual } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";
import * as $s from "../../view/content_library/data_sources_styles.mjs";

class SourceProps extends $CustomType {
  constructor(source, is_last, page) {
    super();
    this.source = source;
    this.is_last = is_last;
    this.page = page;
  }
}

class DataSourcesProps extends $CustomType {
  constructor(org_id, page) {
    super();
    this.org_id = org_id;
    this.page = page;
  }
}

function use_data_sources_fetch(store, page) {
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => {
    return $redraw.use_effect(_capture, [store.organization, page]);
  })(
    () => {
      return $when.some_(
        store.organization,
        $function.always(undefined),
        (org_id) => {
          dispatch($ds_effects.fetch_by_page(org_id, page));
          return undefined;
        },
      );
    },
  );
}

function pagination() {
  return $redraw.component_(
    "Pagination",
    (props) => {
      let store = $store.use_state();
      let $ = $dict.get(store.data_sources.paginated, props.org_id);
      if ($ instanceof Ok) {
        let total = $[0];
        let pages = globalThis.Math.trunc(total / 20);
        let link = (p) => {
          return $a.href("/data-sources?page=" + $int.to_string(p));
        };
        return $s.pagination(
          toList([]),
          toList([
            $s.page_button(
              false,
              toList([$a.disabled(props.page === 0), link(props.page - 1)]),
              toList([$icons.small($icons.arrow_left_line())]),
            ),
            $redraw.fragment(
              (() => {
                let _block;
                let _pipe = $int.range(1, pages + 2, toList([]), $list.prepend);
                _block = $list.reverse(_pipe);
                let pages$1 = _block;
                return $list.map(
                  pages$1,
                  (page) => {
                    let active = props.page === (page - 1);
                    return $s.page_button(
                      active,
                      toList([link(page)]),
                      toList([$h.text($int.to_string(page))]),
                    );
                  },
                );
              })(),
            ),
            $s.page_button(
              false,
              toList([$a.disabled(props.page === pages), link(props.page + 1)]),
              toList([$icons.small($icons.arrow_right_line())]),
            ),
          ]),
        );
      } else {
        return $skeleton.skeleton(10, 30);
      }
    },
  );
}

function card_header(document_id) {
  let checked = new $checkbox.Unchecked();
  let on_check = (_) => { return undefined; };
  return $s.header(
    toList([]),
    toList([
      $icons.small($icons.arrow_dropdown()),
      $s.header_title(toList([]), toList([$h.text(document_id)])),
      $s.viewed_button(
        toList([]),
        toList([$h.text("Viewed"), $checkbox.checkbox(checked, false, on_check)]),
      ),
    ]),
  );
}

function source_language(source) {
  return $when.some(
    source.display.language,
    (language) => {
      return $when.ok(
        $iso639.parse(language),
        (language) => {
          return $label.label(
            toList([
              $label.neutral(),
              $label.content($language.to_string(language)),
            ]),
          );
        },
      );
    },
  );
}

function source_status(source) {
  let content = $data_source.status_to_display(source.status);
  return $label.label(
    toList([$common.status_to_label(source), $label.content(content)]),
  );
}

function on_update_expiration_date(props, dispatch) {
  let source = props.source;
  let page = props.page;
  return $e.on_input(
    (event) => {
      let time = $ievent.value(event);
      let $ = $timestamp_.from_time_input(time);
      if ($ instanceof Ok) {
        let date = $[0];
        let _pipe = $ds_effects.update_expiration_date(source.id, date, page);
        dispatch(_pipe);
        return undefined;
      } else {
        return undefined;
      }
    },
  );
}

function source_expiration_date() {
  return $redraw.component_(
    "DataSources(SourceExpirationDate)",
    (props) => {
      let dispatch = $store.use_effect_dispatch();
      return $s.source_expiration_date_input(
        toList([
          on_update_expiration_date(props, dispatch),
          $a.type_("date"),
          $a.disabled(!props.is_last),
          $a.value(
            (() => {
              let _pipe = props.source.expiration_date;
              let _pipe$1 = $option.map(
                _pipe,
                (_capture) => {
                  return $timestamp_.to_date_yyyymmdd(_capture, "-");
                },
              );
              return $option.unwrap(_pipe$1, "");
            })(),
          ),
        ]),
      );
    },
  );
}

function on_tag_select(dispatch, props, tag_id) {
  let source = props.source;
  let page = props.page;
  dispatch(
    (() => {
      let $ = $list.contains(source.tags, tag_id);
      if ($) {
        return $ds_effects.delete_tag(source, tag_id, page);
      } else {
        return $ds_effects.add_tag(source, tag_id, page);
      }
    })(),
  );
  return undefined;
}

function source_tags() {
  return $compose.children(
    $dropdown.dropdown(),
    (dropdown) => {
      return $redraw.component_(
        "DataSources(SourceTags)",
        (props) => {
          let store = $store.use_state();
          let dispatch = $store.use_effect_dispatch();
          let tags = $dict.get(store.organizations_tags, props.source.org_id);
          if (tags instanceof Ok) {
            let $ = tags[0];
            if ($ instanceof $remote.NotLoaded) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Loading) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Errored) {
              let error = $[0];
              return $h.text(error);
            } else {
              let tags$1 = $[0];
              let on_select = (_capture) => {
                return on_tag_select(dispatch, props, _capture);
              };
              return $l.row(
                toList([$l.gap(12)]),
                toList([]),
                toList([
                  (() => {
                    let _pipe = $dropdown.on_selected_(on_select);
                    let _pipe$1 = $dropdown.placeholder(_pipe, "Assign tags");
                    let _pipe$2 = $dropdown.icon(
                      _pipe$1,
                      $icons.tiny($icons.price_tag()),
                    );
                    let _pipe$3 = $dropdown.disabled(_pipe$2, !props.is_last);
                    return dropdown(
                      _pipe$3,
                      $list.map(
                        tags$1,
                        (tag) => {
                          let _pipe$4 = $dropdown.choice(tag.name, tag.id);
                          return $dropdown.as_selected(
                            _pipe$4,
                            $list.contains(props.source.tags, tag.id),
                          );
                        },
                      ),
                    );
                  })(),
                  $redraw.fragment(
                    $list.filter_map(
                      props.source.tags,
                      (tag) => {
                        return $result.map(
                          $list.find(tags$1, (t) => { return t.id === tag; }),
                          (tag) => {
                            return $s.source_author(
                              toList([]),
                              toList([$h.text(tag.name)]),
                            );
                          },
                        );
                      },
                    ),
                  ),
                ]),
              );
            }
          } else {
            return $skeleton.skeleton(100, 30);
          }
        },
      );
    },
  );
}

function on_select_owner(dispatch, props, owner) {
  let source = props.source;
  let page = props.page;
  let _pipe = $ds_effects.update_owner(source.id, owner, page);
  dispatch(_pipe);
  return undefined;
}

function source_owner() {
  return $compose.children(
    $dropdown.dropdown(),
    (dropdown) => {
      return $redraw.component_(
        "DataSources(SourceOwner)",
        (props) => {
          let store = $store.use_state();
          let dispatch = $store.use_effect_dispatch();
          let users = $dict.get(store.organizations_users, props.source.org_id);
          if (users instanceof Ok) {
            let $ = users[0];
            if ($ instanceof $remote.NotLoaded) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Loading) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Errored) {
              let error = $[0];
              return $h.text(error);
            } else {
              let users$1 = $[0];
              let on_select = (_capture) => {
                return on_select_owner(dispatch, props, _capture);
              };
              let _pipe = $dropdown.on_selected_(on_select);
              let _pipe$1 = $dropdown.panel_position(
                _pipe,
                new $position.Right(),
              );
              let _pipe$2 = $dropdown.selected(_pipe$1, props.source.owner);
              let _pipe$3 = $dropdown.placeholder(_pipe$2, "Assign owner");
              let _pipe$4 = $dropdown.icon(
                _pipe$3,
                $icons.tiny($icons.add_user()),
              );
              let _pipe$5 = $dropdown.disabled(_pipe$4, !props.is_last);
              return dropdown(
                _pipe$5,
                $list.map(
                  users$1,
                  (user) => {
                    let initials = user.initials;
                    let picture = user.picture;
                    let size = new $pp.Small();
                    let _pipe$6 = $dropdown.choice(user.name, user.id);
                    let _pipe$7 = $dropdown.with_icon(
                      _pipe$6,
                      $pp.from_user(picture, initials, size),
                    );
                    return $dropdown.as_selected(
                      _pipe$7,
                      isEqual(props.source.owner, new Some(user.id)),
                    );
                  },
                ),
              );
            }
          } else {
            return $skeleton.skeleton(100, 30);
          }
        },
      );
    },
  );
}

function on_authors_selected(dispatch, props, author) {
  let source = props.source;
  let page = props.page;
  let _pipe = $ds_effects.update_authors(source.id, toList([author]), page);
  dispatch(_pipe);
  return undefined;
}

function source_authors() {
  return $compose.children(
    $dropdown.dropdown(),
    (dropdown) => {
      return $redraw.component_(
        "DataSources(SourceAuthors)",
        (props) => {
          let store = $store.use_state();
          let dispatch = $store.use_effect_dispatch();
          let users = $dict.get(store.organizations_users, props.source.org_id);
          if (users instanceof Ok) {
            let $ = users[0];
            if ($ instanceof $remote.NotLoaded) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Loading) {
              return $skeleton.skeleton(100, 30);
            } else if ($ instanceof $remote.Errored) {
              let error = $[0];
              return $h.text(error);
            } else {
              let users$1 = $[0];
              let _block;
              let _pipe = props.source.authors;
              let _pipe$1 = $list.first(_pipe);
              _block = $option.from_result(_pipe$1);
              let selected = _block;
              let on_selected = (_capture) => {
                return on_authors_selected(dispatch, props, _capture);
              };
              let _pipe$2 = $dropdown.on_selected_(on_selected);
              let _pipe$3 = $dropdown.panel_position(
                _pipe$2,
                new $position.Right(),
              );
              let _pipe$4 = $dropdown.selected(_pipe$3, selected);
              let _pipe$5 = $dropdown.placeholder(_pipe$4, "Assign author");
              let _pipe$6 = $dropdown.icon(
                _pipe$5,
                $icons.tiny($icons.add_user()),
              );
              let _pipe$7 = $dropdown.disabled(_pipe$6, !props.is_last);
              return dropdown(
                _pipe$7,
                $list.map(
                  users$1,
                  (user) => {
                    let initials = user.initials;
                    let picture = user.picture;
                    let size = new $pp.Small();
                    let _pipe$8 = $dropdown.choice(user.name, user.id);
                    let _pipe$9 = $dropdown.with_icon(
                      _pipe$8,
                      $pp.from_user(picture, initials, size),
                    );
                    return $dropdown.as_selected(
                      _pipe$9,
                      isEqual(props.source.owner, new Some(user.id)),
                    );
                  },
                ),
              );
            }
          } else {
            return $skeleton.skeleton(100, 30);
          }
        },
      );
    },
  );
}

function source_version() {
  return $redraw.compose(
    source_authors(),
    (source_authors) => {
      return $redraw.compose(
        source_owner(),
        (source_owner) => {
          return $redraw.compose(
            source_tags(),
            (source_tags) => {
              return $redraw.compose(
                source_expiration_date(),
                (source_expiration_date) => {
                  return $redraw.component_(
                    "DataSources(SourceVersion)",
                    (props) => {
                      return $when.some(
                        props.source.display.qna,
                        (qna) => {
                          let version = "Version " + $int.to_string(
                            props.source.version,
                          );
                          return $s.source_body(
                            toList([]),
                            toList([
                              $s.source_version(
                                toList([]),
                                toList([
                                  $label.label(
                                    toList([$label.content(version)]),
                                  ),
                                ]),
                              ),
                              $s.source_status(
                                toList([]),
                                toList([source_status(props.source)]),
                              ),
                              $s.source_language(
                                toList([]),
                                toList([source_language(props.source)]),
                              ),
                              $s.source_question(
                                toList([]),
                                toList([$h.text(qna.question)]),
                              ),
                              $s.source_answer(
                                toList([]),
                                toList([$h.text(qna.answer)]),
                              ),
                              $s.source_tags(
                                toList([]),
                                toList([source_tags(props)]),
                              ),
                              $s.source_authors(
                                toList([]),
                                toList([source_authors(props)]),
                              ),
                              $s.source_owner(
                                toList([]),
                                toList([source_owner(props)]),
                              ),
                              $s.source_expiration_date(
                                toList([]),
                                toList([source_expiration_date(props)]),
                              ),
                            ]),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function data_sources_cards() {
  return $redraw.compose(
    source_version(),
    (source_version) => {
      return $redraw.component_(
        "DataSources(Cards)",
        (props) => {
          let store = $store.use_state();
          return $when.ok(
            $data_sources.get(store.data_sources, props.org_id, props.page),
            (data) => {
              if (data instanceof $remote.NotLoaded) {
                return $h.text("Unknown state");
              } else if (data instanceof $remote.Loading) {
                return $skeleton.skeleton(100, 100);
              } else if (data instanceof $remote.Errored) {
                let error = data[0];
                return $h.text("An error occured: " + error);
              } else {
                let sources = data[0];
                return $l.column(
                  toList([$l.gap(24)]),
                  toList([]),
                  $list.map(
                    sources,
                    (_use0) => {
                      let document_id = _use0[0];
                      let sources$1 = _use0[1];
                      let last_index = $list.length(sources$1) - 1;
                      return $s.card(
                        toList([]),
                        toList([
                          card_header(document_id),
                          $common.separator(),
                          $s.body(
                            toList([]),
                            (() => {
                              let _pipe = sources$1;
                              let _pipe$1 = $list.index_map(
                                _pipe,
                                (source, index) => {
                                  let is_last = index === last_index;
                                  let _pipe$1 = new SourceProps(
                                    source,
                                    is_last,
                                    props.page,
                                  );
                                  return source_version(_pipe$1);
                                },
                              );
                              return $list.intersperse(
                                _pipe$1,
                                $common.separator(),
                              );
                            })(),
                          ),
                        ]),
                      );
                    },
                  ),
                );
              }
            },
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    data_sources_cards(),
    (data_sources_cards) => {
      return $redraw.compose(
        pagination(),
        (pagination) => {
          return $redraw.component_(
            "DataSources",
            (_use0) => {
              let page = _use0[0];
              let store = $store.use_state();
              use_data_sources_fetch(store, page);
              let $ = store.organization;
              if ($ instanceof Some) {
                let organization = $[0];
                let props = new DataSourcesProps(organization, page);
                return $l.column(
                  toList([$l.gap(24)]),
                  toList([]),
                  toList([
                    $l.row(
                      toList([$l.align("center"), $l.gap(24)]),
                      toList([]),
                      toList([
                        $typography.h1($typography.md, "Data Sources Viewer"),
                      ]),
                    ),
                    data_sources_cards(props),
                    pagination(props),
                  ]),
                );
              } else {
                return $h.none();
              }
            },
          );
        },
      );
    },
  );
}
